module.exports = [
  require('./sacred_stone_monk'),
  require('./skyweaver'),
  require('./stonemelder'),
]
